
// ===== LEADS CRM =====
let leadView='pipeline';
function setLeadView(v){leadView=v;document.getElementById('lead-pipeline-view').style.display=v==='pipeline'?'block':'none';document.getElementById('lead-list-view').style.display=v==='lista'?'block':'none';document.getElementById('btn-lead-pipe').classList.toggle('active',v==='pipeline');document.getElementById('btn-lead-list').classList.toggle('active',v==='lista');renderLeads()}
function renderLeads(){
  const leads=CACHE.leads;
  const ativos=leads.filter(l=>!['fechado','perdido'].includes(l.status));
  const fechados=leads.filter(l=>l.status==='fechado');
  const perdidos=leads.filter(l=>l.status==='perdido');
  const encerrados=fechados.length+perdidos.length;
  const conversao=encerrados?Math.round(fechados.length/encerrados*100):0;
  const ticket=fechados.length?fechados.reduce((a,l)=>a+(l.val||0),0)/fechados.length:0;
  const pipelineAberto=ativos.reduce((a,l)=>a+(l.val||0),0);
  const hoje=today(),followVenc=ativos.filter(l=>l.followup&&l.followup<hoje),semResp=ativos.filter(l=>!l.responsavel);
  document.getElementById('leads-cards').innerHTML=`
    <div class="card accent" onclick="leadView='lista';setLeadView('lista')" title="Oportunidades abertas, exceto ganhas e perdidas"><label>Leads ativos</label><div class="val">${ativos.length}</div><small style="color:var(--muted)">carteira aberta</small></div>
    <div class="card green"><label>Ganhos</label><div class="val">${fechados.length}</div><small style="color:var(--muted)">negócios fechados</small></div>
    <div class="card red"><label>Perdidos</label><div class="val">${perdidos.length}</div><small style="color:var(--muted)">encerrados sem venda</small></div>
    <div class="card purple" title="Ganhos ÷ (ganhos + perdidos)"><label>Conversão comercial</label><div class="val">${conversao}%</div><small style="color:var(--muted)">${fechados.length}/${encerrados||0} encerrados</small></div>
    <div class="card warn"><label>Follow-ups vencidos</label><div class="val">${followVenc.length}</div><small style="color:var(--muted)">exigem retomada</small></div>
    <div class="card accent"><label>Pipeline aberto</label><div class="val">${fmt(pipelineAberto)}</div><small style="color:var(--muted)">ativos, não só negociação</small></div>
    <div class="card red"><label>Sem responsável</label><div class="val">${semResp.length}</div><small style="color:var(--muted)">risco de abandono</small></div>
    <div class="card green"><label>Ticket médio ganho</label><div class="val">${fmt(ticket)}</div></div>`;
  if(leadView==='pipeline')renderLeadPipeline(leads);
  else renderLeadLista(leads);
}
function renderLeadPipeline(leads){
  const board=document.getElementById('pipeline-board');board.innerHTML='';
  LEAD_STAGES.forEach(s=>{
    const f=leads.filter(l=>l.status===s);
    const col=document.createElement('div');col.className='pl-col';
    col.innerHTML=`<div class="pl-head" style="color:${LEAD_COLORS[s]}"><span>${LS[s]}</span><span>${f.length}</span></div><div class="pl-body" id="pl-${s}"></div>`;
    board.appendChild(col);
    const body=col.querySelector('.pl-body');
    // Drop zone
    body.addEventListener('dragover',e=>{e.preventDefault();body.style.background='var(--accent)22';});
    body.addEventListener('dragleave',()=>{body.style.background='';});
    body.addEventListener('drop',async e=>{
      e.preventDefault();body.style.background='';
      const id=e.dataTransfer.getData('text/plain');
      if(!id)return;
      const lista=[...DB.get('leads')];const i=lista.findIndex(x=>x.id===id);
      if(i<0||lista[i].status===s)return;
      const antes=lista[i].status;lista[i].status=s;lista[i].updatedAt=today();
      await DB.set('leads',lista);
      try{await auditar('status','Lead',`${lista[i].nome}: ${LS[antes]} → ${LS[s]}`,{status:antes},{status:s});}catch(e){}
      renderLeads();updateBadges();
      if(s==='fechado'){const l=DB.get('leads').find(x=>x.id===id);if(l&&!l.convertidoEm)promptConverterLead(l);}
    });
    if(!f.length){body.innerHTML='<div style="padding:10px;font-size:11px;color:var(--muted);text-align:center">—</div>';return}
    f.forEach(l=>{
      const flow=commercialFlowStateForLead(l);
      const card=document.createElement('div');card.className='pl-card';
      card.draggable=true;
      card.style.cursor='grab';
      card.addEventListener('dragstart',e=>{e.dataTransfer.setData('text/plain',l.id);card.style.opacity='0.5';});
      card.addEventListener('dragend',()=>{card.style.opacity='';});
      card.onclick=()=>editLead(l.id);
      card.innerHTML=`
        <div style="display:flex;justify-content:space-between;align-items:flex-start">
          <div class="pl-card-name" style="flex:1">${escapeHtml(l.nome)}</div>
          <button onclick="event.stopPropagation();deleteLead('${l.id}')" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:14px;padding:0 0 0 6px;line-height:1" title="Excluir lead">✕</button>
        </div>
        ${l.val?`<div class="pl-card-val">${fmt(l.val)}</div>`:''}
        <div class="pl-card-meta">${escapeHtml(l.origem||'')}${l.followup?` · 🗓️ ${fmtD(l.followup)}${!ehDiaUtil(l.followup)?` <span title="Fim de semana/feriado — próximo dia útil: ${fmtD(proximoDiaUtil(l.followup))}" style="cursor:help">⚠️</span>`:''}`:''}</div>
        <div class="commercial-next" style="margin:8px 0 0;padding:7px 8px"><span><strong>${escapeHtml(flow.status)}</strong><br>${escapeHtml(flow.next)}</span></div>
        ${(l.tel||l.email)?`<div style="margin-top:7px">${quickContactLinks(l.tel,l.email,true)}</div>`:''}
        ${s==='fechado'?`<div style="display:flex;gap:4px;margin-top:6px">
          ${!l.convertidoEm?`<button class="btn btn-primary btn-sm" style="font-size:11px;flex:1" onclick="event.stopPropagation();promptConverterLead(DB.get('leads').find(x=>x.id==='${l.id}'))">👤 Converter em Cliente</button>`:`<span style="font-size:10px;color:var(--green)">✅ Convertido em ${fmtD(l.convertidoEm)}</span>`}
        </div>`:''}
        ${s!=='fechado'&&s!=='perdido'?`
        <div style="display:flex;gap:4px;margin-top:8px">
          ${LEAD_STAGES.indexOf(s)>0?`<button class="btn btn-ghost btn-sm" style="padding:5px 9px" title="Voltar etapa" onclick="event.stopPropagation();moverLead('${l.id}',-1)">◀</button>`:''}
          <button class="btn btn-ghost btn-sm" style="flex:1;font-size:11px;white-space:nowrap" title="Registrar contato de hoje" onclick="event.stopPropagation();registrarContatoLead('${l.id}')">📞 Contato</button>
          ${LEAD_STAGES.indexOf(s)<LEAD_STAGES.length-2?`<button class="btn btn-ghost btn-sm" style="padding:5px 9px" title="Avançar etapa" onclick="event.stopPropagation();moverLead('${l.id}',1)">▶</button>`:''}
        </div>
        <button class="btn btn-primary btn-sm" style="width:100%;margin-top:6px;font-size:11px" onclick="event.stopPropagation();converterLeadCompleto('${l.id}','orcamento')">Gerar orçamento</button>
        <button class="btn btn-ghost btn-sm btn-danger" style="width:100%;margin-top:4px;font-size:11px" title="Arquivar como perdido" onclick="event.stopPropagation();registrarDesistenciaLead('${l.id}')">🗄 Arquivar</button>
        `:''}`;
      body.appendChild(card);
    });
  });
}
function renderLeadLista(leads){
  const tbody=document.getElementById('tabela-leads');
  if(!leads.length){tbody.innerHTML='<tr><td colspan="8" class="empty">Nenhum lead</td></tr>';return}
  const td=today();
  tbody.innerHTML=leads.map(l=>{
    const idade=l.createdAt?Math.max(0,Math.ceil((new Date(td+'T12:00')-new Date(String(l.createdAt).slice(0,10)+'T12:00'))/86400000)):null;
    const diasFollow=l.followup?Math.ceil((new Date(String(l.followup).slice(0,10)+'T12:00')-new Date(td+'T12:00'))/86400000):null;
    const risco=diasFollow!==null&&diasFollow<0?'Follow-up atrasado':!l.responsavel?'Sem responsável':!l.followup&&!['fechado','perdido'].includes(l.status)?'Sem próxima ação':'Em dia';
    const fechado=l.status==='fechado';
    return`<tr>
    <td><strong>${escapeHtml(l.nome)}</strong>${(l.tel||l.email)?`<div style="margin-top:5px">${quickContactLinks(l.tel,l.email,true)}</div>`:''}<br><small style="color:var(--muted)">${escapeHtml(l.email||'')}</small></td>
    <td>${escapeHtml(l.origem||'—')}${l.indicadorNome?`<br><small>${escapeHtml(l.indicadorNome)}</small>`:''}</td><td><strong>${fmt(l.val)}</strong></td>
    <td>${l.followup?`<strong style="color:${diasFollow<0?'var(--red)':diasFollow===0?'var(--warn)':'var(--text)'}">${diasFollow<0?Math.abs(diasFollow)+'d atrasado':diasFollow===0?'Hoje':fmtD(l.followup)}</strong>${!ehDiaUtil(l.followup)?` <span title="Fim de semana/feriado — próximo dia útil: ${fmtD(proximoDiaUtil(l.followup))}" style="cursor:help">⚠️</span>`:''}`:'<span style="color:var(--red)">Sem próxima ação</span>'}<br><small style="color:var(--muted)">Canal: ${escapeHtml(l.canal||l.canalPreferido||'WhatsApp')}</small></td>
    <td>${escapeHtml(l.responsavel||'Sem responsável')}</td>
    <td><span style="color:${risco==='Em dia'?'var(--green)':'var(--red)'}">${escapeHtml(risco)}</span><br><small style="color:var(--muted)">${idade===null?'idade não registrada':idade+' dia(s) no CRM'}</small></td>
    <td><span class="badge b-${l.status}">${LS[l.status]}</span></td>
    <td><div style="display:flex;gap:5px;flex-wrap:wrap">
      ${!['fechado','perdido'].includes(l.status)?`<button class="btn btn-ghost btn-sm" onclick="registrarContatoLead('${l.id}')">Registrar contato</button>`:''}
      ${!['fechado','perdido'].includes(l.status)?`<button class="btn btn-primary btn-sm" onclick="converterLeadCompleto('${l.id}','orcamento')">Gerar orçamento</button><button class="btn btn-danger btn-sm" onclick="registrarDesistenciaLead('${l.id}')">Não fechou / arquivar</button>`:''}
      ${fechado?`<button class="btn btn-ghost btn-sm" onclick="showPage('clientes')">Abrir cliente</button><button class="btn btn-ghost btn-sm" onclick="showPage('pedidos')">Abrir pedido</button>`:''}
      <button class="btn btn-ghost btn-sm" onclick="editLead('${l.id}')">Editar</button>
      <button class="btn btn-ghost btn-sm" onclick="abrirHistoricoDoRegistro('${escapeHtml(l.nome)}')">Histórico</button>
    </div></td>
  </tr>`}).join('');
}
function fmtCep(el){
  let v=el.value.replace(/\D/g,'').slice(0,8);
  el.value=v.length>5?v.slice(0,5)+'-'+v.slice(5):v;
}
// Busca CEP e preenche campo de endereço único (lead, pedido, etc.)
async function buscarCepCampo(val,endId,cepId){
  const cep=val.replace(/\D/g,'');
  // auto-format
  const cepEl=document.getElementById(cepId);
  if(cepEl&&val.length>5&&!val.includes('-'))cepEl.value=cep.slice(0,5)+'-'+cep.slice(5);
  if(cep.length!==8)return;
  try{
    const r=await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const d=await r.json();
    if(d.erro)return;
    const el=document.getElementById(endId);
    if(el){
      const partes=[d.logradouro,d.bairro,[d.localidade,d.uf].filter(Boolean).join(' - ')].filter(Boolean);
      if(!el.value.trim())el.value=partes.join(', ');
    }
  }catch(e){}
}
async function buscarCepLeadCampo(val){
  const cep=val.replace(/\D/g,'');
  const cepEl=document.getElementById('l-cep');
  if(cepEl&&val.length>5&&!val.includes('-'))cepEl.value=cep.slice(0,5)+'-'+cep.slice(5);
  if(cep.length!==8)return;
  try{
    const r=await fetch(`https://viacep.com.br/ws/${cep}/json/`);const d=await r.json();if(d.erro)return;
    const setIfEmpty=(id,v)=>{const el=document.getElementById(id);if(el&&!el.value.trim())el.value=v||'';};
    setIfEmpty('l-end',d.logradouro||'');setIfEmpty('l-bairro',d.bairro||'');setIfEmpty('l-cidade',d.localidade||'');
    const numEl=document.getElementById('l-num');if(numEl&&!numEl.value.trim())setTimeout(()=>numEl.focus(),80);
  }catch(e){}
}
async function buscarCepPedidoCampo(val){
  const cep=val.replace(/\D/g,'');
  const cepEl=document.getElementById('p-cep');
  if(cepEl&&val.length>5&&!val.includes('-'))cepEl.value=cep.slice(0,5)+'-'+cep.slice(5);
  if(cep.length!==8)return;
  try{
    const r=await fetch(`https://viacep.com.br/ws/${cep}/json/`);const d=await r.json();if(d.erro)return;
    const _sf=(id,v)=>{const el=document.getElementById(id);if(el&&!el.value.trim())el.value=v||'';};
    _sf('p-end',d.logradouro||'');_sf('p-bairro',d.bairro||'');_sf('p-cidade',d.localidade||'');
    const ufEl=document.getElementById('p-uf');if(ufEl&&!ufEl.value.trim())ufEl.value=(d.uf||'').toUpperCase();
    const numEl=document.getElementById('p-num-end');if(numEl&&!numEl.value.trim())setTimeout(()=>numEl.focus(),80);
  }catch(e){}
}
async function buscaCep(cep){
  const v=cep.replace(/\D/g,'');if(v.length!==8)return;
  const st=document.getElementById('cli-cep-status');
  if(st)st.textContent='🔍 buscando...';
  try{
    const r=await fetch(`https://viacep.com.br/ws/${v}/json/`);const d=await r.json();
    if(st)st.textContent='';
    if(d.erro){if(st)st.textContent='CEP não encontrado';return;}
    const setIfEmpty=(id,val)=>{const el=document.getElementById(id);if(el&&!el.value.trim())el.value=val||'';};
    setIfEmpty('cli-end',d.logradouro||'');
    setIfEmpty('cli-bairro',d.bairro||'');
    setIfEmpty('cli-cidade',d.localidade||'');
    const ufEl=document.getElementById('cli-uf');if(ufEl&&!ufEl.value.trim())ufEl.value=(d.uf||'').toUpperCase();
    setTimeout(()=>document.getElementById('cli-num')?.focus(),80);
  }catch(e){if(st)st.textContent='';}
}
function fmtCpfCnpj(el){
  let v=el.value.replace(/\D/g,'');
  if(v.length>14)v=v.slice(0,14);
  if(v.length<=11){
    // CPF: 000.000.000-00
    if(v.length<=3) el.value=v;
    else if(v.length<=6) el.value=v.slice(0,3)+'.'+v.slice(3);
    else if(v.length<=9) el.value=v.slice(0,3)+'.'+v.slice(3,6)+'.'+v.slice(6);
    else el.value=v.slice(0,3)+'.'+v.slice(3,6)+'.'+v.slice(6,9)+'-'+v.slice(9);
  } else {
    // CNPJ: 00.000.000/0000-00
    el.value=v.slice(0,2)+'.'+v.slice(2,5)+'.'+v.slice(5,8)+'/'+v.slice(8,12)+'-'+v.slice(12);
  }
}
function fmtTelLead(el){
  return window.PhoneIntelligence?.apply(el,false);
}
function telefoneInfoDoCampo(id){return window.PhoneIntelligence?.metadata(document.getElementById(id)?.value||'')||null}
function fmtValLead(el){
  let v=el.value.replace(/\D/g,'');
  if(!v){el.value='';return;}
  const n=parseInt(v,10)/100;
  el.value='R$ '+n.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2});
}
function onLeadStatusChange(status){
  const ff=document.getElementById('l-followup-field');
  const fi=document.getElementById('l-followup');
  if(status==='fechado'){
    ff.style.opacity='0.4';ff.style.pointerEvents='none';fi.value='';
  } else {
    ff.style.opacity='';ff.style.pointerEvents='';
  }
  document.getElementById('l-motivo-field').style.display=status==='perdido'?'':'none';
  if(status!=='perdido')document.getElementById('l-motivo').value='';
}
let _leadPedrasSel=new Set();
let _leadAmbientesSel=new Set();
const LEAD_AMBIENTES=['Cozinha','Banheiro','Lavabo','Área gourmet','Lavanderia','Escada','Soleiras','Sala / painel','Quarto','Fachada','Outro'];
function _chipStyle(on){return `display:inline-flex;align-items:center;gap:5px;border:1.5px solid ${on?'var(--accent)':'var(--border)'};border-radius:20px;padding:4px 11px;font-size:12px;cursor:pointer;user-select:none;${on?'background:color-mix(in srgb,var(--accent) 12%,transparent);font-weight:700':''}`}
function leadPedraCatalogoNomes(){
  const base=Object.values(typeof CATALOGO_BASE_PEDRAS==='object'?CATALOGO_BASE_PEDRAS:{}).flat();
  return [...new Set([...(DB.get('pedras')||[]).map(p=>p.nome).filter(Boolean),...base])];
}
function leadPedraKey(v){
  return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-zA-Z0-9]+/g,'').toLowerCase();
}
function corrigirMojibakeUtf8(s){
  // Reconstrói bytes que foram lidos como Latin-1 OU Windows-1252.
  // O Windows-1252 é necessário para casos como "Ã”nix": ” é U+201D, mas representa o byte 0x94.
  const cp1252=new Map([
    ['€',0x80],['‚',0x82],['ƒ',0x83],['„',0x84],['…',0x85],['†',0x86],['‡',0x87],['ˆ',0x88],
    ['‰',0x89],['Š',0x8a],['‹',0x8b],['Œ',0x8c],['Ž',0x8e],['‘',0x91],['’',0x92],['“',0x93],
    ['”',0x94],['•',0x95],['–',0x96],['—',0x97],['˜',0x98],['™',0x99],['š',0x9a],['›',0x9b],
    ['œ',0x9c],['ž',0x9e],['Ÿ',0x9f]
  ]);
  const umaPassagem=str=>{
    if(!/[ÃÂ]/.test(str))return str;
    try{
      const bytes=[];
      for(const ch of str){
        const code=ch.codePointAt(0);
        const byte=code<=255?code:cp1252.get(ch);
        if(byte===undefined)return str;
        bytes.push(byte);
      }
      return new TextDecoder('utf-8',{fatal:true}).decode(Uint8Array.from(bytes))||str;
    }catch(e){return str}
  };
  let atual=String(s||'');
  for(let i=0;i<3;i++){
    const proxima=umaPassagem(atual);
    if(proxima===atual)break;
    atual=proxima;
  }
  return atual;
}
function corrigirNomePedraLead(nome){
  let s=String(nome||'').trim().replace(/\s+/g,' ');
  if(!s)return '';
  s=corrigirMojibakeUtf8(s);
  // Primeira letra acentuada perdida na origem (ex.: "nix Branco" -> "Ônix Branco")
  s=s.replace(/^nix\b/i,'Ônix');
  // Rede de segurança para variações específicas que a reversão genérica não cobrir
  const moji=String.fromCharCode(195),ced=String.fromCharCode(167),ag=String.fromCharCode(161),iag=String.fromCharCode(173),oug=String.fromCharCode(186),eag=String.fromCharCode(170),atil=String.fromCharCode(163);
  const trocas=[
    [new RegExp('^'+'[A\\u00C1\\u00C0\\u00C2\\u00C3]'+'\\?nix','i'),'Ônix'],
    [new RegExp('Floren'+moji+ced+'a','gi'),'Florença'],
    [new RegExp('Icara'+moji+iag,'gi'),'Icaraí'],
    [new RegExp('Maracuja|Maracuj'+moji+ag,'gi'),'Maracujá'],
    [new RegExp('S'+moji+atil+'o','gi'),'São'],
    [new RegExp('Tom'+moji+eag,'gi'),'Tomé'],
    [new RegExp('Cec'+moji+iag+'lia','gi'),'Cecília'],
    [new RegExp('Maca'+moji+oug+'bas','gi'),'Macaúbas'],
    [new RegExp('Ita'+moji+oug+'nas','gi'),'Itaúnas'],
    [new RegExp('Cear'+moji+ag,'gi'),'Ceará'],
    [new RegExp('Paran'+moji+ag,'gi'),'Paraná'],
    [new RegExp('Pigu'+moji+eag+'s','gi'),'Piguês']
  ];
  trocas.forEach(([re,ok])=>{s=s.replace(re,ok)});
  const alvo=leadPedraKey(s),match=leadPedraCatalogoNomes().find(n=>leadPedraKey(n)===alvo);
  const canonicos={'pedrasotom':'Pedra São Tomé','pedrasotome':'Pedra São Tomé','pedrasaotom':'Pedra São Tomé','pedrasaotome':'Pedra São Tomé','onixbranco':'Ônix Branco','onixmel':'Ônix Mel'};
  return canonicos[alvo]||match||s;
}
function leadPedrasSetNormalizado(valores){
  return new Set([...(valores||[])].map(corrigirNomePedraLead).filter(Boolean));
}
function renderLeadPedrasChips(){
  const el=document.getElementById('l-pedras-chips');if(!el)return;
  const q=(document.getElementById('l-pedras-busca')?.value||'').trim().toLowerCase();
  const qKey=leadPedraKey(q);
  _leadPedrasSel=leadPedrasSetNormalizado(_leadPedrasSel);
  const todos=[...new Set([...leadPedraCatalogoNomes(),..._leadPedrasSel].map(corrigirNomePedraLead).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'pt'));
  const marcadas=todos.filter(n=>_leadPedrasSel.has(n));
  const demais=todos.filter(n=>!_leadPedrasSel.has(n)&&(!qKey||leadPedraKey(n).includes(qKey)));
  const nomes=[...marcadas,...demais];
  el.innerHTML=nomes.length?nomes.map(n=>`<span style="${_chipStyle(_leadPedrasSel.has(n))}" onclick="toggleLeadPedra('${escapeHtml(n).replace(/'/g,"\\'")}')">${_leadPedrasSel.has(n)?'✓ ':''}${escapeHtml(n)}</span>`).join(''):(q?`<span style="font-size:11px;color:var(--muted)">Nenhuma pedra encontrada para "${escapeHtml(q)}".</span>`:'<span style="font-size:11px;color:var(--muted)">Cadastre pedras no Catálogo para listar aqui.</span>');
}
function toggleLeadPedra(nome){nome=corrigirNomePedraLead(nome);if(_leadPedrasSel.has(nome))_leadPedrasSel.delete(nome);else _leadPedrasSel.add(nome);renderLeadPedrasChips();}
function renderLeadAmbientesChips(){
  const el=document.getElementById('l-ambientes-chips');if(!el)return;
  const usados=(CACHE.leads||[]).flatMap(l=>l.ambientes||[]);
  const base=LEAD_AMBIENTES.filter(n=>n!=='Outro');
  const todos=[...new Set([...base,...usados,..._leadAmbientesSel])].filter(n=>n!=='Outro');
  el.innerHTML=todos.map(n=>`<span style="${_chipStyle(_leadAmbientesSel.has(n))}" onclick="toggleLeadAmbiente('${escapeHtml(n).replace(/'/g,"\\'")}')">${_leadAmbientesSel.has(n)?'✓ ':''}${escapeHtml(n)}</span>`).join('')+
    `<span style="${_chipStyle(false)};border-style:dashed" onclick="novoLeadAmbiente()">+ Novo ambiente</span>`;
}
async function novoLeadAmbiente(){
  const nome=String(await uiPrompt({eyebrow:'Novo lead',title:'Adicionar ambiente de interesse',message:'Identifique o espaço para organizar necessidades, medidas preliminares e orçamento.',label:'Nome do ambiente',placeholder:'Ex.: Varanda, piscina ou consultório',confirmLabel:'Adicionar ambiente'})||'').trim();
  if(!nome)return;
  const norm=nome.replace(/\s+/g,' ');
  _leadAmbientesSel.add(norm.charAt(0).toUpperCase()+norm.slice(1));
  renderLeadAmbientesChips();
}
function toggleLeadAmbiente(nome){if(_leadAmbientesSel.has(nome))_leadAmbientesSel.delete(nome);else _leadAmbientesSel.add(nome);renderLeadAmbientesChips();}
function initLeadModal(d={}){
  document.getElementById('lid').value=d.id||'';
  document.getElementById('l-nome').value=d.nome||'';
  const _lCliId=document.getElementById('l-clienteId');if(_lCliId)_lCliId.value=d.clienteId||'';
  const _lCliLnk=document.getElementById('l-cliente-link');if(_lCliLnk)_lCliLnk.style.display=d.clienteId?'':'none';
  // Telefone formatado
  const telEl=document.getElementById('l-tel');telEl.value=d.tel||'';
  // Produtos do catálogo de pedras
  // Pedras (seleção múltipla) — compatível com leads antigos (prod string)
  document.getElementById('l-email').value=d.email||'';
  document.getElementById('l-doc').value=d.doc||'';
  const lEndEl=document.getElementById('l-end');if(lEndEl)lEndEl.value=d.end||'';
  const lCepEl=document.getElementById('l-cep');if(lCepEl)lCepEl.value=d.cep||'';
  const lNumEl=document.getElementById('l-num');if(lNumEl)lNumEl.value=d.num||'';
  const lCompEl=document.getElementById('l-comp');if(lCompEl)lCompEl.value=d.comp||'';
  const lBairroEl=document.getElementById('l-bairro');if(lBairroEl)lBairroEl.value=d.bairro||'';
  const lCidadeEl=document.getElementById('l-cidade');if(lCidadeEl)lCidadeEl.value=d.cidade||'';
  const buscaPedras=document.getElementById('l-pedras-busca');if(buscaPedras)buscaPedras.value='';
  _leadPedrasSel=leadPedrasSetNormalizado(Array.isArray(d.pedras)&&d.pedras.length?d.pedras:(d.prod?String(d.prod).split(/\s*,\s*/).filter(Boolean):[]));
  _leadAmbientesSel=new Set(Array.isArray(d.ambientes)?d.ambientes:[]);
  renderLeadPedrasChips();
  renderLeadAmbientesChips();
  // Valor formatado
  const valEl=document.getElementById('l-val');
  if(d.val){const n=parseFloat(d.val)||0;valEl.value=n?'R$ '+n.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:2}):'';}else valEl.value='';
  document.getElementById('l-origem').value=d.origem||'';
  preencherIndicadoresLead(d.indicadorId||'');preencherIndicadoresClienteLead(d.indicadorClienteId||'');
  onLeadOrigemChange();
  if(d.indicadorId)onLeadIndicadorChange(d.indicadorId);
  if(d.indicadorClienteId)onLeadIndicadorClienteChange(d.indicadorClienteId);
  document.getElementById('l-status').value=d.status||'novo';
  document.getElementById('l-followup').value=d.followup||'';
  document.getElementById('l-motivo').value=d.motivo||'';
  document.getElementById('l-obs').value=d.obs||'';
  onLeadStatusChange(d.status||'novo');
  const saveBtn=document.getElementById('l-save-btn');if(saveBtn){saveBtn.className=d.id?'btn btn-ghost btn-sm':'btn btn-primary';}
  document.getElementById('l-convert-btn').style.display=d.id&&!['fechado','perdido'].includes(d.status)?'inline-flex':'none';
  document.getElementById('l-convert-btn').dataset.id=d.id||'';
  document.getElementById('l-orcamento-btn').style.display=d.id&&d.status!=='perdido'?'inline-flex':'none';
  document.getElementById('l-orcamento-btn').dataset.id=d.id||'';
  const desistBtn=document.getElementById('l-desistencia-btn');if(desistBtn){desistBtn.style.display=d.id&&!['fechado','perdido'].includes(d.status)?'inline-flex':'none';desistBtn.dataset.id=d.id||'';}
}
function onLeadNomeInput(nome){
  const linkDiv=document.getElementById('l-cliente-link');
  const idEl=document.getElementById('l-clienteId');
  // Tenta encontrar cliente exato pelo nome (escolhido no datalist)
  const cli=(CACHE.clientes||[]).find(c=>c.nome===nome.trim());
  if(cli){
    // Preenche campos do lead com dados do cliente (só se estiver vazio)
    const setIfEmpty=(id,val)=>{const el=document.getElementById(id);if(el&&!el.value.trim())el.value=val||'';};
    setIfEmpty('l-tel',cli.tel||cli.telefone||'');
    setIfEmpty('l-email',cli.email||'');
    setIfEmpty('l-doc',cli.cpfcnpj||'');
    setIfEmpty('l-end',cli.end||cli.endereco||'');
    setIfEmpty('l-num',cli.num||'');setIfEmpty('l-comp',cli.comp||'');setIfEmpty('l-bairro',cli.bairro||'');setIfEmpty('l-cidade',cli.cidade||'');
    if(!document.getElementById('l-origem').value&&cli.origem)document.getElementById('l-origem').value=cli.origem;
    if(idEl)idEl.value=cli.id;
    if(linkDiv)linkDiv.style.display='';
  }else{
    if(idEl)idEl.value='';
    if(linkDiv)linkDiv.style.display='none';
  }
}
function editLead(id){const l=DB.get('leads').find(x=>x.id===id);openModal('modal-lead',l)}
async function salvarLead(){
  if(!validarFormulario([{id:'l-nome',label:'Nome do lead'}]))return;
  const nome=document.getElementById('l-nome').value.trim();
  const eid=document.getElementById('lid').value;const lista=[...DB.get('leads')];
  const antes=eid?lista.find(x=>x.id===eid):null;
  const novoStatus=document.getElementById('l-status').value;
  const valRaw=document.getElementById('l-val').value.replace(/[R$\s.]/g,'').replace(',','.');
  const lIndicadorId=document.getElementById('l-indicador-id')?.value||'';
  const lIndicador=parceirosComerciais().find(f=>f.id===lIndicadorId);
  const lIndicadorClienteId=document.getElementById('l-indicador-cliente-id')?.value||'';
  const lIndicadorClienteRec=(CACHE.clientes||DB.get('clientes')||[]).find(c=>c.id===lIndicadorClienteId);
  const pedrasLead=[...leadPedrasSetNormalizado(_leadPedrasSel)];
  const obj={...(antes||{}),id:eid||uid(),nome,tel:document.getElementById('l-tel').value,origem:document.getElementById('l-origem').value,email:document.getElementById('l-email').value.trim(),doc:document.getElementById('l-doc').value.trim(),cep:(document.getElementById('l-cep')?.value||'').trim(),end:(document.getElementById('l-end')?.value||'').trim(),num:(document.getElementById('l-num')?.value||'').trim(),comp:(document.getElementById('l-comp')?.value||'').trim(),bairro:(document.getElementById('l-bairro')?.value||'').trim(),cidade:(document.getElementById('l-cidade')?.value||'').trim(),indicadorId:lIndicadorId,indicadorNome:lIndicador?nomeParceiro(lIndicador):'',indicadorComissaoPct:Number(lIndicador?.comissao)||0,indicadorClienteId:lIndicadorClienteId,indicadorClienteNome:lIndicadorClienteRec?(lIndicadorClienteRec.nome||lIndicadorClienteRec.razao||''):'',pedras:pedrasLead,ambientes:[..._leadAmbientesSel],prod:pedrasLead.join(', '),val:parseFloat(valRaw)||0,status:novoStatus,followup:document.getElementById('l-followup').value,ultimoContato:antes?.ultimoContato||'',motivo:document.getElementById('l-motivo').value,obs:document.getElementById('l-obs').value,clienteId:document.getElementById('l-clienteId')?.value||antes?.clienteId||'',createdAt:eid?antes?.createdAt||today():today(),updatedAt:today()};
  if(novoStatus==='fechado')carimbarFechamentoComercial(obj,{closedAt:antes?.fechadoEm,source:antes?.fechamentoOrigem||'lead_fechado'});
  if(eid){const i=lista.findIndex(x=>x.id===eid);if(i>=0)lista[i]=obj;else lista.unshift(obj)}else lista.unshift(obj);
  await DB.set('leads',lista);
  await auditar(eid?'editou':'criou','Lead',`${eid?'Editou':'Adicionou'} lead ${nome}`,antes,obj);
  closeModal('modal-lead');renderLeads();updateBadges();
  // Se acabou de fechar o lead, oferecer conversão
  const foiAberto=!antes||antes.status!=='fechado';
  if(novoStatus==='fechado'&&foiAberto) promptConverterLead(obj);
  else toast('Lead salvo ✓');
}
async function registrarContatoLead(id){const lista=DB.get('leads'),i=lista.findIndex(l=>l.id===id);if(i<0)return;const antes={...lista[i]};lista[i].ultimoContato=today();lista[i].followup=addDays(today(),1);lista[i].updatedAt=today();await DB.set('leads',lista);await auditar('editar','Lead',`Registrou retomada comercial com ${lista[i].nome}`,antes,lista[i]);renderLeads();renderAgenda();updateBadges();toast('Contato de hoje registrado ✓')}
async function moverLead(id,dir){
  const l=[...DB.get('leads')];const i=l.findIndex(x=>x.id===id);if(i<0)return;
  const cur=LEAD_STAGES.indexOf(l[i].status);const next=cur+dir;
  if(next<0||next>=LEAD_STAGES.length)return;
  const antes=l[i].status;l[i].status=LEAD_STAGES[next];l[i].updatedAt=today();
  if(LEAD_STAGES[next]==='fechado')carimbarFechamentoComercial(l[i],{source:'lead_fechado'});
  await DB.set('leads',l);await auditar('status','Lead',`${l[i].nome}: ${LS[antes]} → ${LS[LEAD_STAGES[next]]}`,{status:antes},{status:LEAD_STAGES[next]});
  renderLeads();updateBadges();
  // Se moveu para fechado, oferecer conversão
  if(LEAD_STAGES[next]==='fechado') promptConverterLead(l[i]);
}
let _motivoNaoFechamentoResolver=null;
let _motivoNaoFechamentoSelecionado='';
function selecionarMotivoNaoFechamento(btn){
  _motivoNaoFechamentoSelecionado=btn?.dataset?.motivo||'';
  document.querySelectorAll('#nf-motivos button').forEach(b=>{
    const on=b===btn;
    b.classList.toggle('btn-primary',on);
    b.classList.toggle('btn-ghost',!on);
  });
  const msg=document.getElementById('nf-validacao');if(msg)msg.style.display='none';
}
function solicitarMotivoNaoFechamento({tipo='registro',nome='',motivoAtual=''}={}){
  const modal=document.getElementById('modal-nao-fechamento');
  if(!modal)return Promise.resolve((motivoAtual||'Sem retorno').trim());
  const title=document.getElementById('nf-modal-title'),sub=document.getElementById('nf-modal-sub'),obs=document.getElementById('nf-observacao'),msg=document.getElementById('nf-validacao');
  _motivoNaoFechamentoSelecionado='';
  document.querySelectorAll('#nf-motivos button').forEach(b=>{b.classList.remove('btn-primary');b.classList.add('btn-ghost')});
  if(title)title.textContent=tipo==='lead'?'Arquivar lead por não fechamento':'Arquivar orçamento por não fechamento';
  if(sub)sub.textContent=nome?`Registro: ${nome}. Escolha o motivo principal para manter o histórico comercial claro.`:'Escolha o motivo principal para manter o histórico comercial claro.';
  if(obs)obs.value=motivoAtual&&!['Preço','Prazo','Pagamento','Concorrente','Sem retorno','Obra adiada','Outro','Desistiu / não fechou'].includes(motivoAtual)?motivoAtual:'';
  if(msg){msg.textContent='';msg.style.display='none'}
  openModal('modal-nao-fechamento');
  return new Promise(resolve=>{_motivoNaoFechamentoResolver=resolve});
}
function cancelarMotivoNaoFechamento(){
  closeModal('modal-nao-fechamento');
  if(_motivoNaoFechamentoResolver){_motivoNaoFechamentoResolver(null);_motivoNaoFechamentoResolver=null}
}
function confirmarMotivoNaoFechamento(){
  const obs=(document.getElementById('nf-observacao')?.value||'').trim();
  const msg=document.getElementById('nf-validacao');
  if(!_motivoNaoFechamentoSelecionado){if(msg){msg.textContent='Escolha um motivo para arquivar.';msg.style.display='block'}return}
  if(_motivoNaoFechamentoSelecionado==='Outro'&&!obs){if(msg){msg.textContent='Descreva o motivo quando selecionar Outro.';msg.style.display='block'}return}
  const motivo=_motivoNaoFechamentoSelecionado==='Outro'?obs:(obs?`${_motivoNaoFechamentoSelecionado} — ${obs}`:_motivoNaoFechamentoSelecionado);
  closeModal('modal-nao-fechamento');
  if(_motivoNaoFechamentoResolver){_motivoNaoFechamentoResolver(motivo);_motivoNaoFechamentoResolver=null}
}
async function registrarDesistenciaLead(idArg=''){
  const id=idArg||document.getElementById('lid')?.value||document.getElementById('l-desistencia-btn')?.dataset.id||'';
  const motivo=(await solicitarMotivoNaoFechamento({tipo:'lead',nome:document.getElementById('l-nome')?.value||'',motivoAtual:document.getElementById('l-motivo')?.value||''})||'').trim();
  if(!motivo)return;
  if(!id){
    document.getElementById('l-status').value='perdido';
    document.getElementById('l-motivo').value=motivo;
    onLeadStatusChange('perdido');
    toast('Arquivamento marcado. Salve o lead para registrar.');
    return;
  }
  const lista=[...DB.get('leads')],i=lista.findIndex(x=>x.id===id);
  if(i<0){toast('Lead não encontrado.','error');return;}
  const antes={...lista[i]};
  lista[i]={...lista[i],status:'perdido',motivo,perdidoEm:new Date().toISOString(),followup:'',updatedAt:today()};
  await DB.set('leads',lista);
  await auditar('status','Lead',`Arquivou lead por não fechamento ${lista[i].nome}: ${motivo}`,antes,lista[i]);
  closeModal('modal-lead');renderLeads();renderAgenda();updateBadges();toast('Lead arquivado como não fechado. Histórico preservado.');
}
async function deleteLead(id){const l=DB.get('leads').find(x=>x.id===id);if(!await uiConfirm({tone:'danger',eyebrow:'Funil comercial',title:'Excluir este lead?',message:l?.nome||'Lead sem nome',impact:'O contato sairá do funil comercial. A exclusão será registrada na auditoria.',confirmLabel:'Excluir lead'}))return;await DB.remove('leads',id);await auditar('excluiu','Lead',`Excluiu lead ${l?.nome}`,l,null);renderLeads();updateBadges()}

function promptConverterLead(lead){
  const m=document.createElement('div');
  m.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.75);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box';
  m.id='_conv-modal';
  m.innerHTML=`<div style="background:#1a1f2e;border-radius:16px;padding:28px;max-width:420px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.7)">
    <div style="font-size:28px;text-align:center;margin-bottom:12px">👤</div>
    <div style="font-size:17px;font-weight:700;text-align:center;margin-bottom:6px">Cliente demonstrou fechamento</div>
    <div style="font-size:13px;color:var(--muted);text-align:center;margin-bottom:24px"><strong>${escapeHtml(lead.nome)}</strong> deve seguir pelo fluxo comercial. Escolha o próximo passo.</div>
    <div style="display:flex;flex-direction:column;gap:10px">
      <button class="btn btn-primary" onclick="converterLeadCompleto('${lead.id}','orcamento')" style="justify-content:center;padding:12px">
        Criar cliente + gerar orçamento
        <span style="display:block;font-size:11px;font-weight:400;opacity:.8">Caminho padrão: proposta aprovada depois vira contrato, recebíveis e produção</span>
      </button>
      <button class="btn btn-ghost" onclick="converterLeadCompleto('${lead.id}','medicao')" style="justify-content:center;padding:12px">
        Abrir medição preliminar
        <span style="display:block;font-size:11px;font-weight:400;opacity:.7">Use quando a medição for necessária para montar o orçamento</span>
      </button>
      <button class="btn btn-ghost" onclick="converterLeadCompleto('${lead.id}','cliente')" style="justify-content:center;padding:12px">
        Só cadastrar cliente
        <span style="display:block;font-size:11px;font-weight:400;opacity:.7">Cadastra o cliente para uso posterior</span>
      </button>
      <button class="btn btn-ghost" onclick="document.getElementById('_conv-modal').remove();toast('Lead salvo ✓')" style="justify-content:center">
        Fechar sem converter
      </button>
    </div>
  </div>`;
  document.body.appendChild(m);
  m.addEventListener('click',e=>{if(e.target===m){m.remove();toast('Lead salvo ✓')}});
}

async function converterLeadCompleto(leadId, modo){
  document.getElementById('_conv-modal')?.remove();
  const lead=DB.get('leads').find(x=>x.id===leadId);if(!lead)return;
  // v350: guarda de dupla conversão (local + servidor) — dois usuários convertendo o
  // mesmo lead geravam clientes duplicados.
  if(lead.convertidoEm||lead.clienteId){toast('Este lead já foi convertido em cliente.','error');try{renderLeads()}catch(e){}return}
  try{
    const snapLead=await appCollection('leads').doc(leadId).get();
    const srvLead=snapLead.exists?snapLead.data():null;
    if(srvLead&&(srvLead.convertidoEm||srvLead.clienteId)){toast('Este lead acabou de ser convertido por outro usuário.','error');try{renderLeads()}catch(e){}return}
  }catch(e){console.warn('Verificação do lead no servidor falhou; usando cache local',e)}
  // Verifica se cliente já existe
  const clienteExistente=CACHE.clientes.find(c=>String(c.nome||'').toLowerCase()===String(lead.nome||'').toLowerCase());
  let clienteId=clienteExistente?.id;
  if(!clienteId){
    // Cria cliente automaticamente — id determinístico por lead (idempotente:
    // repetir a conversão nunca gera um segundo cliente)
    const novoCliente={id:'cli_lead_'+leadId,nome:lead.nome,tel:lead.tel||'',email:lead.email||'',cpfcnpj:lead.doc||'',perfil:lead.perfil||'cliente',origem:lead.origem||'',end:lead.end||'',num:lead.num||'',comp:lead.comp||'',cep:lead.cep||'',bairro:lead.bairro||'',cidade:lead.cidade||'',uf:lead.uf||'',obs:`Convertido do lead em ${today()}`,operationId:'conversao_lead_'+leadId,leadId,createdAt:new Date().toISOString(),updatedAt:new Date().toISOString()};
    if(window.CommercialClosure?.isLeadClosed(lead))carimbarFechamentoComercial(novoCliente,{closedAt:lead.fechadoEm,source:lead.fechamentoOrigem||'lead_convertido',leadId});
    const clientes=[...DB.get('clientes'),novoCliente];
    await DB.set('clientes',clientes); // já atualiza CACHE.clientes internamente
    clienteId=novoCliente.id;
    try{await auditar('criou','Cliente',`Cliente criado a partir do lead: ${lead.nome}`,null,novoCliente);}catch(e){console.warn('Auditoria falhou (cliente salvo)',e);}
    populateClientesDatalist();
    if(typeof renderClientes==='function'&&document.getElementById('page-clientes')?.classList.contains('active'))renderClientes();
    toast('Cliente criado ✓');
  } else {
    toast('Cliente já existia, vinculado ✓');
  }
  // Atualiza lead com referência ao cliente
  const leads=[...DB.get('leads')];const li=leads.findIndex(x=>x.id===leadId);
  if(li>=0){leads[li].clienteId=clienteId;leads[li].convertidoEm=today();if(leads[li].status==='fechado')carimbarFechamentoComercial(leads[li],{closedAt:leads[li].fechadoEm,source:leads[li].fechamentoOrigem||'lead_convertido',customerId:clienteId});await DB.set('leads',leads);}
  try{renderLeads();}catch(e){}
  if(modo==='orcamento'){
    const interesse=[(lead.pedras||[]).length?'Interesse: '+lead.pedras.join(', '):'',(lead.ambientes||[]).length?'Ambientes: '+lead.ambientes.join(', '):''].filter(Boolean).join('\n');
    setTimeout(()=>{
      openModal('modal-pedido',{status:'orcado',clienteId,leadId,cliente:lead.nome||'',tel:lead.tel||'',email:lead.email||'',cpfcnpj:lead.doc||'',origem:lead.origem||'',valor:lead.val||'',
        end:lead.end||'',endNum:lead.num||'',endComp:lead.comp||'',bairro:lead.bairro||'',cidade:lead.cidade||'',cep:lead.cep||'',
        desc:interesse,obs:lead.obs||''});
      toast('Orçamento pré-preenchido com os dados do lead ✓');
    },300);
    return;
  }
  if(modo==='pedido'||modo==='medicao'){
    setTimeout(()=>{
      openMedicaoForm(null,{clienteId,origemSolicitacao:'whatsapp',obs:lead.prod||''});
    },300);
  }
}

function converterLead(id){converterLeadCompleto(id,'medicao')}
function convertLeadToPedido(){const id=document.getElementById('l-convert-btn').dataset.id;closeModal('modal-lead');converterLeadCompleto(id,'pedido')}
function gerarOrcamentoDoLead(){const id=document.getElementById('l-orcamento-btn').dataset.id||document.getElementById('lid').value;if(!id){toast('Salve o lead antes de gerar o orçamento.','error');return}closeModal('modal-lead');converterLeadCompleto(id,'orcamento')}

